import { GetDocumentListResponse, TravelerNamesInner } from 'src/sdk-servicing';

/**
 * 搭乗者情報データモデル
 */
export interface ETicketEmdSelectTravelerInfo {
  readonly eTicketNumber: string;
  readonly issuedDate: string;
  readonly travelerId?: string;
  readonly travelerName: TravelerNamesInner;
  /** 航空券表示フラグ */
  readonly isDisplayAvailable?: boolean;
}

/**
 * 区間情報データモデル
 */
export interface EmdSelectSectionInfo {
  departureDate: string;
  departureLocationName: string;
  arrivalLocationName: string;
}

/**
 * EMDリストデータモデル
 */
export interface EmdListInfo {
  emdNumber: string;
  issuedDate: string;
  travelerName: {
    fullNameWithTitle: string;
    firstName: string;
    lastName: string;
  };
}

export module ETicketEmdHandler {
  export function toTravelerList(response: GetDocumentListResponse): ETicketEmdSelectTravelerInfo[] {
    // 空の画面表示用航空券リスト
    const eTicketViewList: ETicketEmdSelectTravelerInfo[] = [];
    for (let eTicket of response.data.eTicketList) {
      for (let counter = 0; counter < eTicket.travelerList.length; counter++) {
        const traveler = eTicket.travelerList[counter];
        // 搭乗者別航空券情報
        let item = {
          eTicketNumber: traveler.eTicketNumber ?? '', // isDisplayAvailable = falseの場合、航空券PDF取得APIを呼び出さないため空文字を設定する
          issuedDate: traveler.issuedDate ?? '', // isDisplayAvailable = falseの場合、発行日を表示しないため空文字を設定する
          travelerId: traveler.travelerId,
          travelerName: traveler.travelerName,
          isDisplayAvailable: traveler.isDisplayAvailable,
        };
        eTicketViewList.push(item);
      }
    }
    return eTicketViewList;
  }
}
